(function() {
    const menuButton = document.querySelector('.menu-button');
    const navLinks = document.querySelector('.nav-links');
    menuButton.addEventListener('click', ()=>{
        navLinks.classList.toggle('active');
    });
})();

//# sourceMappingURL=index.5a6640f5.js.map
